// 权限是否通过

function packageFunc (val) {
	if(localStorage.getItem('permissionList')==undefined){
		return false
	}
	let list=localStorage.getItem('permissionList').split(',');
	// alert(list)
 //  let list=['e4b0bee8-b178-4369-9fb3-965810ca3ea1','e4b0bee8-b178-4369-9fb3-965810ca3eb1','e4b0bee8-b178-4369-9fb3-965810ca3ec1',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3ed1',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3ee1',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3ef1','e4b0bee8-b178-4369-9fb3-965810ca3dcb','e4b0bee8-b178-4369-9fb3-965810ca3dcc','e4b0bee8-b178-4369-9fb3-965810ca3dbd',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3dbb','e4b0bee8-b178-4369-9fb3-965810ca3dbc','e4b0bee8-b178-4369-9fb3-965810ca3dca','e4b0bee8-b178-4369-9fb3-965810ca3dcd',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3dfl','e4b0bee8-b178-4369-9fb3-965810ca3dfo','e4b0bee8-b178-4369-9fb3-965810ca3dfp','e4b0bee8-b178-4369-9fb3-965810ca3dfq',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3dbx','e4b0bee8-b178-4369-9fb3-965810ca3dek','e4b0bee8-b178-4369-9fb3-965810ca3dem','e4b0bee8-b178-4369-9fb3-965810ca3dfa',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3den','e4b0bee8-b178-4369-9fb3-965810ca3dfb','e4b0bee8-b178-4369-9fb3-965810ca3dfc','e4b0bee8-b178-4369-9fb3-965810ca3dbs',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3dbe','e4b0bee8-b178-4369-9fb3-965810ca3dav','e4b0bee8-b178-4369-9fb3-965810ca3daw','e4b0bee8-b178-4369-9fb3-965810ca3dbf',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3dep','e4b0bee8-b178-4369-9fb3-965810ca3deq','e4b0bee8-b178-4369-9fb3-965810ca3dbm','e4b0bee8-b178-4369-9fb3-965810ca3dbp',
 // 'e4b0bee8-b178-4369-9fb3-965810ca3dbo','e4b0bee8-b178-4369-9fb3-965810ca3dbn']
 for(let i of list){
 	if(i==val){
 		return true
 	}
 }
 return false
}

export default {
  // Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
  install: function (Vue) {
    Vue.prototype.isJurisdiction = (val) => packageFunc(val)
  }
}


// WEBPACK FOOTER //
// ./src/utils/isJurisdiction.js